import React, { useEffect, useState } from 'react';
import './Wish.css';
import { useSelector, useDispatch } from 'react-redux';
import { getWithTokenAPI, postWithTokenAPI } from '../../util/Api';
import "react-toastify/dist/ReactToastify.css";
import { showToastSuccessMsg, showToastErrorMsg } from '../../store/toastMsg';
import { decrementWishlistCount, setWishlistCount, removeFromWishlist } from '../../store/wishlistSlice';
import { addToCart, setCart, setTotalItems, setTotalPrice, setCartId } from "../../store/cartSlice";
// import { addToCart, setCart, setTotalItems, setTotalPrice, setCartId } from "../../store/cartSlice";
import wish from '../../assets/wishlistss.png'
import { toast } from 'react-toastify';
import LoginPopup from '../Loginpopup/Loginpop';
import { useNavigate } from 'react-router-dom';

const Wishlist = () => {
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.auth?.auth?.access_token);
  const userId = useSelector((state) => state.auth?.auth?._id);
  const isLoggedIn = useSelector((state) => state.auth?.isLoggedIn);
  const [wishlistItems, setWishlistItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate =useNavigate();
  // const [addingToCart, setAddingToCart] = useState({});
  const [addingToCart, setAddingToCart] = useState(false);

  const [hoveredItem, setHoveredItem] = useState(null);
  const [removingItem, setRemovingItem] = useState(null);
  const [isLoginPopupOpen, setLoginPopupOpen] = useState(false);

  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchWishlist = async () => {
    if (!isLoggedIn || !accessToken) {
      setLoading(false);
      setWishlistItems([]);
      return;
    }
    setLoading(true);
    try {
      const response = await getWithTokenAPI(accessToken, `/wishlist/find-all?user_id=${userId}`);
      if (response?.statusCode === 200) {
        const wishlistData = response.data?.wishlist || [];
        const formattedWishlist = wishlistData.map(item => ({
          ...item,
          product_id: item.product_id || item._id,
          _id: item._id
        }));
        setWishlistItems(formattedWishlist);
        dispatch(setWishlistCount(formattedWishlist.length));
      } else {
        console.warn("Failed to fetch wishlist:", response);
        setError('Failed to load wishlist.');
        setWishlistItems([]);
      }
    } catch (err) {
      console.error("Error fetching wishlist:", err);
      setError('An error occurred while fetching your wishlist.');
      setWishlistItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWishlist();
  }, [accessToken, isLoggedIn, userId]);




  const handleAddToCart = async (cartItem) => {
    if (!accessToken) {
      setLoginPopupOpen(true);
      return;
    }
    if (!cartItem?._id) return;

    if (addingToCart) return;
    setAddingToCart(true);
    setError(null);

    try {
      const payload = {
        cart: [
          {
            product_id: cartItem._id,
            quantity: cartItem.quantity > 0 ? cartItem.quantity : 1,
          },
        ],
      };

      const response = await postWithTokenAPI(accessToken, "/cart/add", payload);

      // 🧹 Case: Cart emptied
      if (
        response?.statusCode === 200 &&
        response?.message === "Product removed and cart deleted as it became empty"
      ) {
        dispatch(setCart([]));
        dispatch(setTotalItems(0));
        dispatch(setTotalPrice(0));
        dispatch(setCartId(null));
        toast.info("Item removed and cart is now empty.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: `removed-${cartItem._id}`,
          theme: "light",
        });
      }

      // ✅ Case: Product added successfully
      else if (response?.statusCode === 200 && response.data?.cart) {
        const addedItem = response.data.cart;

        dispatch(
          addToCart({
            id: addedItem.product_id,
            price: addedItem.price,
            quantity: addedItem.quantity,
            name: addedItem.name,
            image: addedItem.image,
          })
        );

        toast.success("Item added to cart successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: `cart-${cartItem._id}`,
          theme: "light",
        });
      }

      // ❌ Failure case
      else {
        toast.error("Failed to add item to cart.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: `error-${cartItem._id}`,
          theme: "light",
        });
      }
    } catch (error) {
      console.error("Add to cart error:", error);
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: `error-${cartItem._id}`,
        theme: "light",
      });
    } finally {
      setAddingToCart(false);
    }
  };


  const closeLoginPopup = () => {
    setLoginPopupOpen(false);
  };
  const handleRemove = async (wishlistItemId, productName) => {
    if (!isLoggedIn || !accessToken) {
      showToastErrorMsg("Please log in to update your wishlist.", 'login-required');
      return;
    }

    if (!wishlistItemId || removingItem === wishlistItemId) return;
    setRemovingItem(wishlistItemId);

    try {
      const wishlistItem = wishlistItems.find(item => item._id === wishlistItemId);
      const actualProductIdToRemove = wishlistItem?.product_id?._id || wishlistItem?.product_id;

      if (!actualProductIdToRemove) {
        showToastErrorMsg("Could not identify product to remove.");
        setRemovingItem(null);
        return;
      }

      const response = await postWithTokenAPI(accessToken, "/wishlist/add", {
        product_id: actualProductIdToRemove,
      });

      if (response?.statusCode === 200 || response?.statusCode === 406) {
        showToastSuccessMsg(`${productName || 'Item'} removed from wishlist`, `wishlist-success-${wishlistItemId}`);
        await fetchWishlist();
      } else {
        showToastErrorMsg(response?.message || "Failed to remove item from wishlist", `wishlist-error-${wishlistItemId}`);
      }
    } catch (error) {
      console.error("Error removing from wishlist:", error);
      showToastErrorMsg("Error removing from wishlist", `wishlist-error-${wishlistItemId}`);
    } finally {
      setRemovingItem(null);
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '50px', fontSize: '18px' }}>Loading wishlist...</div>;
  }

  if (!isLoggedIn) {
    return <div style={{ textAlign: 'center', padding: '50px', fontSize: '18px' }}>Please log in to see your wishlist.</div>;
  }

  if (error) {
    return <div style={{ textAlign: 'center', padding: '50px', color: 'red', fontSize: '18px' }}>Error: {error}</div>;
  }

 if (wishlistItems.length === 0) {
  return (
    <div className="empty-wishlist-container">
      <div className="empty-wishlist-content">
        <div className="empty-wishlist-illustration">
          <div className='d-flex justify-content-center'>
     <img src={wish} className='empty-wish-img'></img>
          </div>
       
          <div className="empty-wishlist-message">
            <h3>Your wishlist is currently empty</h3>
            <p>Start exploring and save what you love!</p>
          </div>
        </div>
        
     
        
        <button className="empty-wishlist-button" onClick={() => navigate('/')}>
          Start Shopping
        </button>
      </div>
    </div>
  );
}

  if (isMobileView) {
    return (
      <>
        {isLoginPopupOpen && <LoginPopup onClose={closeLoginPopup} />}

        <h5 className='wishtext'>My Wishlist</h5>
        <div className="wishlist-grid-mobile">
          {wishlistItems.map((item) => {
            const product = item.product_id && typeof item.product_id === 'object' ? item.product_id : item;
            if (!product || !product._id) return null;

            const isItemAddingToCart = addingToCart[product._id];
            const isItemRemoving = removingItem === item._id;

            return (
              <div key={item._id} className="wishlist-card-mobile">
                <div className="wishlist-card-img-container">
                  <img
                    src={product.product_image?.[0] || "/fallback.jpg"}
                    alt={product.name || 'Product Image'}
                    className="wishlist-card-img"
                  />
                </div>
                <div className="wishlist-card-name">
                  {product.name || 'Product Name N/A'}
                </div>
                <div className="wishlist-card-price">
                  {product.discount_price ? (
                    <>
                      <span className="current-price-box">Ksh {product.discount_price.toFixed(2)}</span>
                      {product.original_price && (
                        <span className="old-price-box">Ksh {product.original_price.toFixed(2)}</span>
                      )}
                    </>
                  ) : product.original_price ? (
                    <span className="current-price-box">Ksh {product.original_price.toFixed(2)}</span>
                  ) : (
                    'Price N/A'
                  )}
                </div>
                <div className="wishlist-card-actions">
                  <button
                    className={`wish-btn wish-btn-add ${isItemAddingToCart ? 'wish-btn-add-disabled' : ''}`}
                    // onClick={() => handleAddToCart(product)}
                    onClick={() => handleAddToCart({ ...product, quantity: 1 })}

                    disabled={isItemAddingToCart}
                  >
                    {isItemAddingToCart ? "Adding..." : "Add to Cart"}
                  </button>
                  <button
                    className="wish-btn-remove"
                    onClick={() => handleRemove(item._id, product.name)}
                    disabled={isItemRemoving}
                  >
                    {isItemRemoving ? <div className="loader-small" /> : '×'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  }

  return (
    <>
      <h5 className='wishtext'>My Wishlist</h5>
      <div className="wishlist-box">
        <table className="wishlist-table">
          <thead>
            <tr>
              <th className="wishlist-th">Product</th>
              <th className="wishlist-th">Price</th>
              <th className="wishlist-th">Action</th>
            </tr>
          </thead>
          <tbody>
            {wishlistItems.map((item) => {
              const product = item.product_id && typeof item.product_id === 'object' ? item.product_id : item;
              if (!product || !product._id) return null;

              const isItemAddingToCart = addingToCart[product._id];
              const isItemRemoving = removingItem === item._id;

              return (
                <tr key={item._id} className="wishlist-row">
                  <td data-label="Product" className="wishlist-product-info">
                    <img
                      src={product.product_image?.[0] || "/fallback.jpg"}
                      alt={product.name || 'Product Image'}
                      className="wishlist-img"
                    />
                    <span className="wishlist-product-title">{product.name || 'Product Name N/A'}</span>
                  </td>
                  <td data-label="Price" className="wishlist-price">
                    {product.discount_price ? (
                      <>
                        <span className="current-price-box">Ksh {product.discount_price.toFixed(2)}</span>
                        {product.original_price && (
                          <span className="old-price-box">Ksh {product.original_price.toFixed(2)}</span>
                        )}
                      </>
                    ) : product.original_price ? (
                      <span className="current-price-box">Ksh {product.original_price.toFixed(2)}</span>
                    ) : (
                      'Price N/A'
                    )}
                  </td>
                  <td data-label="Action">
                    <div className="wishlist-actions">
                      <button
                        className={`Wish-btn wish-btn-add ${isItemAddingToCart ? 'wish-btn-add-disabled' : ''}`}
                        // onClick={() => handleAddToCart(product)}
                        onClick={() => handleAddToCart({ ...product, quantity: 1 })}

                        disabled={isItemAddingToCart}
                      >
                        {isItemAddingToCart ? "Adding..." : "Add to Cart"}
                      </button>
                      <button
                        className="wish-btn-remove"
                        onClick={() => handleRemove(item._id, product.name)}
                        disabled={isItemRemoving}
                      >
                        {isItemRemoving ? <div className="loader-small" /> : '×'}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Wishlist;
